export const createCodeRedemptionRedeemRequest = (code) => {
  return {
    url: "/redemption_codes/redeem",
    method: "POST",
    data: {
      code,
    },
  };
};
